import WarningIcon from "@mui/icons-material/Warning";
import { Tooltip, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.swaYellow,
  },
  toolTip: {
    maxWidth: "200px",
    fontSize: "12px",
  },
}));

const StarsWarningIcon = (props) => {
  const classes = useStyles();

  return props.toolTipMessage ? (
    <Tooltip
      title={
        <React.Fragment>
          <Typography color="inherit" fontSize="14px" fontWeight="bold">
            {props.toolTipHeader}
          </Typography>
          {props.toolTipMessage}
        </React.Fragment>
      }
      arrow
      placement="right"
      classes={{ tooltip: classes.toolTip }}
    >
      <WarningIcon className={classes.icon} />
    </Tooltip>
  ) : (
    <WarningIcon className={classes.icon} sx={{ fontSize: props.fontSize ? props.fontSize : "30px" }} />
  );
};

StarsWarningIcon.propTypes = {
  toolTipHeader: PropTypes.string,
  toolTipMessage: PropTypes.string,
  fontSize: PropTypes.string,
};

export default StarsWarningIcon;
